export default __webpack_public_path__ + "static/media/team-active.e14fbbb2.svg";